import {DashboardConstants} from "../redux_constants/dashboard.constant";

const InitialState = {
    numPages: 1,
    pageNumber: 1,
    total: 1,
    isBusy: false, 
    drawerCollapsed: false, 
    allTags: [],
    ids_to_poll: [],
    analysis_key_prefixes: {}
}

export const dashboardReducer = ( state = InitialState , action) => {
    switch(action.type){
        case DashboardConstants.CHANGE_PAGE:
            return {
                ...state, 
                pageNumber: action.pageNumber
            }
        case DashboardConstants.CHANGE_TOTAL_NUMBER_OF_PAGES:
            return {
                ...state, 
                numPages: action.numPages
            }
        case DashboardConstants.CHANGE_TOTAL_SLIDES:
            return {
                ...state, 
                total: action.total
            }
        case DashboardConstants.CLOSE_DRAWER:
            return {
                ...state, 
                drawerCollapsed: true
            }
        case DashboardConstants.OPEN_DRAWER:
            return {
                ...state, 
                drawerCollapsed: false
            }
        case DashboardConstants.INIT_TAGS:
            return {
                ...state, 
                allTags: action.tags
            }
        case DashboardConstants.ADD_TAG:
            return {
                ...state, 
                allTags: [...state.allTags, action.tag]
            }
        case DashboardConstants.ADD_TO_POLLER:
            let { ids_to_poll = [] } = action
            if (!Array.isArray(ids_to_poll)) {
                ids_to_poll = [ids_to_poll]
            }
            const new_ids_to_poll = [... new Set([...state.ids_to_poll, ...ids_to_poll])]
            return {
                ...state,
                ids_to_poll: new_ids_to_poll
            }
        case DashboardConstants.CLEAR_AND_ADD_TO_POLLER:
            let newIdsToPoll = action.ids_to_poll || [];
            if (!Array.isArray(newIdsToPoll)) {
                newIdsToPoll = [newIdsToPoll];
            }
            return {
                ...state,
                ids_to_poll: newIdsToPoll
            };
        case DashboardConstants.CLEAR_POLLER:
            return {
                ...state,
                ids_to_poll: []
            }
        case DashboardConstants.REMOVE_FROM_POLLER:
            let { ids_to_remove = [] } = action
            if (!Array.isArray(ids_to_remove)) {
                ids_to_remove = [ids_to_remove]
            }
            const new_ids_to_poll_ = state.ids_to_poll.filter( (el) => !ids_to_remove.includes(el))
            return {
                ...state,
                ids_to_poll: new_ids_to_poll_
            }
        case DashboardConstants.UPDATE_ANALYSIS_KEYS:
            let new_key_prefixes = {};
            Object.keys(action.data).forEach(id => {
                // take all keys in action.data[id]
                // like county#focus#t0_i1_c1, take#focus#0, scan#focus
                // and update state's analysis_key_prefixes object
                Object.keys(action.data[id]).forEach(key => {
                    let parts = key.split("#");
                    if (!(parts[0] in state.analysis_key_prefixes)) {
                        new_key_prefixes[parts[0]] = false;
                    }
                    let twoLevelKey = `${parts[0]}#${parts[1]}`;
                    if ( !(twoLevelKey in state.analysis_key_prefixes) ) {
                        new_key_prefixes[twoLevelKey] = false;
                    }
                });
            });
            return {
                ...state,
                analysis_key_prefixes: Object.assign(state.analysis_key_prefixes, new_key_prefixes)
            }
        case DashboardConstants.SET_ANALYSIS_FILTER_BOOL:
            let updated_key_prefixes = Object.assign({}, state.analysis_key_prefixes);
            updated_key_prefixes[action.key] = action.checked;
            return {
                ...state,
                analysis_key_prefixes: updated_key_prefixes
            }
        default :
            return state
    }
}